import { useEffect, useRef } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import { MENU_ITEMS } from './config';
import { getSlugValue } from './helpers/urlHelpers';

const Routes = () => {
  const contentRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;

    if (!hash) {
      contentRef.current.scrollTop = 0;
    }
  }, [location]);

  return (
    <div className="content" ref={contentRef}>
      <div className="content-inside">
        <Switch>
          {MENU_ITEMS.map(item => (
            <Route path={'/' + getSlugValue(item.label)} component={item.component} key={item.label} />
          ))}
          <Redirect to="/installation" from="/" exact />
        </Switch>
      </div>
    </div>
  )
}

export default Routes;
